import React from 'react';
import View3DImage from './View3DImage';
import ViewZoomInOut from './ViewZoomInOut';
import WishlistNotificationSuccess from './WishlistNotificationSuccess';
import CommonModal from './CommonModal';
import AddToCompareModal from './AddToCompareModal';
import LogoutConfirmModal from './LogoutConfirmModal';
import LogoutSuccessfulModal from './LogoutSuccessfulModal';
import LoginSuccessfulModal from './LoginSuccessfulModal';
// import ProductAvailableModal from './ProductAvailableModal';
import StoreShowsOnMapModal from './StoreShowsOnMapModal';
import ShareStoreLocationModal from './ShareStoreLocationModal';
import CartItemRemoveConfirmModal from './CartItemRemoveConfirmModal';
import CartItemRemoveSuccessModal from './CartItemRemoveSuccessModal';
import UnavailableCartItemRemoveModal from './UnavailableCartItemRemoveModal';
import UnavailableCartItemRemoveWarningModal from './UnavailableCartItemRemoveWarningModal';
import ShareJobLinkModal from './ShareJobLinkModal';
import JobSearchModal from './JobSearchModal';
import SearchHistoryClearModal from './SearchHistoryClearModal';
import EMIDetailsModal from './EMIDetailsModal';
import NotificationOnModal from './NotificationOnModal';
import RemoveFromWishlistModal from './RemoveFromWishlistModal';
import WishlistItemRemoveConfirmModal from './WishlistItemRemoveConfirmModal';
import AddEmailPhoneModal from './AddEmailPhoneModal';
import SeeFullImage from './SeeFullImage';
import EmiTableModal from './EmiTableModal';
import CartItemRemoveAllConfirmModal from './CartItemRemoveAllConfirmationModal';
import CartItemRemoveAllItemSuccessModal from './CartItemRemoveAllSuccessModal';
import ReorderAllItemsModal from './ReorderAllItemsModal';
import CheckOrderStatus from './CheckOrderStatus';
import RemoveAddressModal from './RemoveAddressModal';
import CommonShareLinkModal from './CommonShareLinkModal';
import WishlistItemRemoveSuccessModal from './WishlistItemRemoveSuccessModal';
import CartItemInstallationFeeRemoveConfirmModal from './CartItemInstallationFeeRemoveConfirmModal';
import CommonWarningModal from './CommonWarningModal';
import OrderCancelationRequest from './OrderCancelationRequest';
import OrderCancelationSuccess from './OrderCancelationSuccess';
import ChatMenuModal from './ChatMenuModal';
import CaptureImage from './CaptureImage';

function Modal(props) {
  const { type, ...rest } = props;

  switch (type) {
    case 'common-modal':
      return <CommonModal {...rest} />;
    case 'common-warning-modal':
      return <CommonWarningModal {...rest} />;
    case 'wishlist-item-remove-success-model':
      return <WishlistItemRemoveSuccessModal {...rest} />;
    case 'view-3d-image':
      return <View3DImage {...rest} />;
    case 'view-zoom-in-out':
      return <ViewZoomInOut {...rest} />;
    case 'wishlist-notification':
      return <WishlistNotificationSuccess {...rest} />;
    case 'add-to-compare-modal':
      return <AddToCompareModal {...rest} />;
    case 'logout-confirm-modal':
      return <LogoutConfirmModal {...rest} />;
    case 'logout-successful-modal':
      return <LogoutSuccessfulModal {...rest} />;
    case 'login-successful-modal':
      return <LoginSuccessfulModal {...rest} />;
    // TODO: we need to implement this modal
    // case 'product-available-modal':
    //   return <ProductAvailableModal {...rest} />;
    case 'store-shows-on-map-modal':
      return <StoreShowsOnMapModal {...rest} />;
    case 'share-store-location-modal':
      return <ShareStoreLocationModal {...rest} />;
    case 'cart-item-remove-confirm-modal':
      return <CartItemRemoveConfirmModal {...rest} />;
    case 'cart-item-installation-fee-remove-confirm-modal':
      return <CartItemInstallationFeeRemoveConfirmModal {...rest} />;
    case 'cart-item-remove-success-modal':
      return <CartItemRemoveSuccessModal {...rest} />;
    case 'unavailable-cart-item-remove-modal':
      return <UnavailableCartItemRemoveModal {...rest} />;
    case 'unavailable-cart-item-remove-warning-modal':
      return <UnavailableCartItemRemoveWarningModal {...rest} />;
    case 'share-job-link-modal':
      return <ShareJobLinkModal {...rest} />;
    case 'job-search-modal':
      return <JobSearchModal {...rest} />;
    case 'search-history-clear-modal':
      return <SearchHistoryClearModal {...rest} />;
    case 'emi-details-modal':
      return <EMIDetailsModal {...rest} />;
    case 'notification-on-modal':
      return <NotificationOnModal {...rest} />;
    case 'remove-from-wishlist-modal':
      return <RemoveFromWishlistModal {...rest} />;
    case 'wishlist-item-remove-confirm-modal':
      return <WishlistItemRemoveConfirmModal {...rest} />;
    case 'add-email-phone-from-profile':
      return <AddEmailPhoneModal {...rest} />;
    case 'see-full-image':
      return <SeeFullImage {...rest} />;
    case 'share-product-link-modal':
      return <CommonShareLinkModal {...rest} />;
    case 'common-share-link-modal':
      return <CommonShareLinkModal {...rest} />;
    case 'emi-table-modal':
      return <EmiTableModal {...rest} />;
    case 'cart-item-remove-all-confirm-modal':
      return <CartItemRemoveAllConfirmModal {...rest} />;
    case 'cart-item-remove-all-success-modal':
      return <CartItemRemoveAllItemSuccessModal {...rest} />;
    case 'reorder-all-items-modal':
      return <ReorderAllItemsModal {...rest} />;
    case 'check-order-status-modal':
      return <CheckOrderStatus {...rest} />;
    case 'remove-address-modal':
      return <RemoveAddressModal {...rest} />;
    case 'order-cancalation-request':
      return <OrderCancelationRequest {...rest} />;
    case 'order-cancalation-success':
      return <OrderCancelationSuccess {...rest} />;
    case 'chat-menu-modal':
      return <ChatMenuModal {...rest} />;
    case 'capture-image':
      return <CaptureImage {...rest} />;
    default:
      return '';
  }
}

export default Modal;
